module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-192x192-0351526575fb3fb09f4404c6383c3889.png";